import React, {Component} from 'react';
import _ from 'lodash';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { MergeAttributes } from '../../FlatData';

import UserStore from '../../../stores/UserStore';
import PositionStore from '../../../stores/PositionStore';
import Loading from '../../Loading';

export default class SelectUsers extends Component {
	constructor(props){
		super(props)

		this.state = {
			isDataFetched: false,
			users: [],
			selected: [],
			pagination: {},
      searchText: ''
		}

		this.onRowSelect = this.onRowSelect.bind(this)
		this.handleSave = this.handleSave.bind(this)
		this.fullnameFormat = this.fullnameFormat.bind(this)
		this.positionFormat = this.positionFormat.bind(this)

		this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
	}

	componentWillMount() {
		const active_page = this.state.pagination.active_page || 1;
    const { searchText } = this.state;

		UserStore.request({url: `users?page=${active_page}&searchText=${searchText}`}).then((resp)=>{
			const users = _.get(resp.data, 'data', []);
			const pagination = _.get(resp.data, 'meta.pagination', {});

			this.setState({
				users: users,
				pagination: pagination
			})
		}).then(() => {
			if (!_.isEmpty(this.props.focus.id)){
				PositionStore.request({id: this.props.focus.id}).then((resp) => {
					var position = resp.data.data;
					var user_ids = _.map(position.attributes.users, 'id');
					this.setState({
						selected: user_ids,
						isDataFetched: true
					})
				})
			}
		})
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.focus.id !== nextProps.focus.id){
			PositionStore.request({id: this.props.focus.id}).then((resp) => {
				var position = _.get(resp.data, 'data', {});
				var user_ids = _.map(position.attributes.users, 'id');
				this.setState({
					selected: user_ids,
					isDataFetched: true
				})
			})
		}
	}

	onRowSelect(row, isSelected, e) {
		var selected = _.clone(this.state.selected)
		var isIncluded = _.includes(selected, row.id)

		if (isIncluded){
			selected = _.pull(selected, row.id)
		}else{
			selected = _.concat(selected, row.id)
		}
	  	this.setState({selected: selected})
	}

	handleSave(event){
		event.preventDefault();
		PositionStore.save(this.props.focus.id, {
			position: {
				user_ids: this.state.selected
			}
		}).then(() => {
			this.props.onCloseAndReloadData()
		})
	}

	positionFormat(cell, row){
		return (
			<div style={{whiteSpace: 'normal'}}>{row.position_names}</div>
		)
	}

	fullnameFormat(cell, row){
		return (
			<div style={{whiteSpace: 'normal'}}>{row.full_name}</div>
		)
	}

	_setTableOption(){ 
     	if(this.state.isDataFetched){
           	return "Not found";
      	}else{
            return <Loading />
      	}
	}

  handlePageChange(page, sizePerPage){
    this.setState({isDataFetched: false, users: []});
    const { searchText } = this.state;

    UserStore.request({url: `users?page=${page}&searchText=${searchText}`}).then((resp)=>{
      const users = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        users: users,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

  handleSearchChange(searchText){
    if (searchText.length === 1) { return }
    this.setState({isDataFetched: false, users: []});

    UserStore.request({url: `users?page=1&searchText=${searchText}`}).then((resp)=>{
      const users = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        users: users,
        pagination: pagination,
        searchText: searchText
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    })
  }

	render(){
		const selectRowProp = {
		  	mode: 'checkbox',
		  	clickToSelect: true,
  			onSelect: this.onRowSelect,
  			selected: this.state.selected
		};
		var data = MergeAttributes(this.state.users);
		const total_items_count = _.get(this.state.pagination, 'total_items_count', 0);
    const active_page = _.get(this.state.pagination, 'active_page', 1);
		const options = {
				noDataText: this._setTableOption(),
      	sizePerPageList: [],
      	sizePerPage: 10,
      	page: active_page,
	      onPageChange: this.handlePageChange,
	      onSearchChange: this.handleSearchChange,
	      searchDelayTime: 500
	    };
		return (
			<div>
				<form onSubmit={this.handleSave}>
					<BootstrapTable 
						data={data}
						remote={ true }
        		fetchInfo={{dataTotalSize: total_items_count}}
						search={ true }
						multiColumnSearch={ true }
						selectRow={ selectRowProp }
						options={options}
						striped
						hover
						condensed
						pagination
						version='4'
						tableContainerClass={'table-sm'}>
							<TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
						  	<TableHeaderColumn dataField='code' dataSort={ true } width='120px'>Code</TableHeaderColumn>
						  	<TableHeaderColumn dataField='full_name' dataSort={ true } dataFormat={this.fullnameFormat}>Fullname</TableHeaderColumn>
						  	<TableHeaderColumn dataField='position_names' dataSort={ true } dataFormat={this.positionFormat}>Position(s)</TableHeaderColumn>
					</BootstrapTable>
					<div className="modal-footer row">
						<button type='submit' className="btn btn-primary pointer">Save changes</button>
						<button type='button' className="btn btn-secondary pointer" onClick={()=>this.props.onClose()}>Close</button>
					</div>
				</form>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/manage_users/users/SelectUsers.js